module.exports = __webpack_public_path__ + "img/ico-pin.2c7dbf60.svg";